export default "__VITE_ASSET__D0tYfD2___"